import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import Icon from '../Unistyles/Icon';

export default function Paginator({
  previousPage,
  nextPage,
  limit = 0,
  offset = 0,
  total = 0,
}: {
  previousPage: () => void;
  nextPage: () => void;
  limit: number;
  offset: number;
  total: number;
}) {
  const numberOfPages = Math.ceil(total / limit);
  const currentPage = offset / limit + 1;

  return numberOfPages > 1 ? (
    <Box
      direction="horizontal"
      space="md"
      align="center"
      justify="center"
      w="full"
      alignSelf="center"
      p="xl"
    >
      <Button
        iconOnly
        size="sm"
        shape="circle"
        variant="primary"
        appearance="outline"
        onPress={previousPage}
        disabled={currentPage <= 1}
      >
        <Icon name="chevron-back-outline" />
      </Button>
      <Text>
        Page {currentPage} / {numberOfPages}
      </Text>
      <Button
        iconOnly
        size="sm"
        shape="circle"
        variant="primary"
        appearance="outline"
        onPress={nextPage}
        disabled={currentPage >= numberOfPages}
      >
        <Icon name="chevron-forward-outline" />
      </Button>
    </Box>
  ) : null;
}
